export default "{\n    \"yes\": \"Oui\",\n    \"no\": \"Non\"\n}\n"